import { styled } from "@phntms/css-components";
import { LanguageBar } from "@itchannelplus/ui/components/LanguageBar";
import { I18nLink } from "@/i18n/routing";
import styles from "./styles.module.scss";
import { ButtonLink } from "@itchannelplus/ui/components/buttons/Button";

export const LogoTitle = styled("span", {
  css: styles.logoTitle,
});

export const Logo = styled("div", {
  css: styles.logo,
  variants: {
    color: {
      white: styles.white,
      black: styles.black,
    },
    thin: {
      true: styles.thin,
    },
  },
});

export const StyledHeader = styled("header", {
  css: styles.header,
  variants: {
    thin: {
      true: styles.thin,
    },
    isMenuOpened: {
      true: styles.menuOpened,
    },
    disableShadow: {
      true: styles.disableShadow,
    },
  },
});

export const HeaderContainer = styled("div", {
  css: styles.headerContainer,
});
export const SearchButton = styled(I18nLink, {
  css: styles.searchButton,
});
export const ContactButton = styled(ButtonLink, {
  css: styles.contactButton,
});



export const StyledLanguageBar = styled(LanguageBar, {
  css: [styles.headerLanguageBar],
  variants: {
    hide: {
      "below-mobile": "hide-below-mobile",
      "over-mobile": "hide-over-mobile",
      "below-tablet": "hide-below-tablet",
      "over-tablet": "hide-over-tablet",
    },
  },
});

export const Nav = styled("nav", {
  css: [styles.nav],
});
export const NavLeft = styled("div", {
  css: [styles.navLeft],
});
export const NavRight = styled("div", {
  css: [styles.navRight],
});

export const MenuButton = styled("button", {
  css: styles.menuButton,
  variants: {
    isMenuOpened: {
      true: styles.menuOpened,
    },
  },
});

export const MenuButtonLine1 = styled("span", {
  css: styles.line1,
});
export const MenuButtonLine2 = styled("span", {
  css: styles.line2,
});
export const MenuButtonLine3 = styled("span", {
  css: styles.line3,
});
export const MenuButtonLabel = styled("span", {
  css: styles.label,
});
